/** Sidebar / route policy for Yardi Resident Matching screens. */
export const YARDI_MATCHING_MENU_POLICY = 'yardi_matching_menu'

/** Cron Jobs row whose daily/weekly schedule can be edited. */
export const YARDI_RESIDENT_MATCHING_CRON_ID = 'YARDI_RESIDENT_MATCHING'
